const typographyFormParamUser = {
  text: 'Información del Usuario',
  inspector: 'Inspector',
  inspectorHelperText: 'El acceso de Inspector solo permite crear servicios y editar las acciones de las que es responsable. Todas las demás creaciones y ediciones están bloqueadas.',
};

export default typographyFormParamUser;
